// @flow

import {havePermission} from "./utils"

export default class ProAccountPermissions {

  canCreateRestaurant(proRole:ProRole = null): boolean {
    return havePermission(
      'proAccount.restaurant.canCreateRestaurant',
      proRole
    );
  }

  canArchiveRestaurant(proRole:ProRole = null): boolean {
    return havePermission(
      'proAccount.restaurant.canDelete',
      proRole
    );
  }

  canReadRole(proRole:ProRole = null): boolean {
    return havePermission(
      'proAccount.role',
      proRole
    );
  }

  canEditRole(proRole:ProRole = null): boolean {
    return havePermission(
      'proAccount.role.canCreateRole',
      proRole
    );
  }

  canDeleteRole(proRole:ProRole = null): boolean {
    return havePermission(
      'proAccount.role.canCreateRole',
      proRole
    );
  }

  canCreateRole(proRole:ProRole = null): boolean {
    return havePermission(
      'proAccount.role.canCreateRole',
      proRole
    );
  }

  canEditSelfAccount(proRole:ProRole = null): boolean {
    return havePermission(
      'proAccount.self.canEditAccount',
      proRole
    );
  }

}
